import React, { useMemo, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Home.scss';
import { FiArrowRight, FiZap, FiShield, FiTruck, FiSend, FiPlus, FiHeadphones } from 'react-icons/fi';

const Home = () => {
  const productData = useMemo(
    () => [
      {
        key: 'double',
        label: '양면테이프',
        eng: 'DOUBLE-SIDED TAPE',
        items: [
          {
            id: 1,
            name: '화지양면',
            desc: '다양한 산업 공정에서 안정적인 부착력과 작업성을 제공하는 대표 양면테이프 제품입니다.',
            image: '/images/tape1.png',
            link: '/products/double-sided/whaja',
          },
          {
            id: 2,
            name: '핫멜트양면',
            desc: '우수한 점착력과 작업 효율을 바탕으로 폭넓게 적용되는 양면테이프입니다.',
            image: '/images/tape1.png',
            link: '/products/double-sided/hotmelt',
          },
          {
            id: 3,
            name: 'PET90 양면',
            desc: '정밀한 가공성과 내구성이 필요한 산업 환경에 적합한 PET 계열 양면테이프입니다.',
            image: '/images/tape1.png',
            link: '/products/double-sided/pet90',
          },
          {
            id: 4,
            name: '크라프트양면',
            desc: '실용성과 경제성을 함께 갖춘 산업용 양면테이프 제품입니다.',
            image: '/images/tape4.png',
            link: '/products/double-sided/kraft',
          },
          {
            id: 5,
            name: '인쇄양면 테이프',
            desc: '강력한 초기 점착력으로 다양한 피착제에 대응 가능한 고성능 테이프입니다.',
            image: '/images/tape10.png',
            link: '/products/double-sided/crown',
          },
        ],
      },
      {
        key: 'industrial',
        label: '산업용 테이프',
        eng: 'INDUSTRIAL TAPE',
        items: [
          {
            id: 6,
            name: '마스킹테이프',
            desc: '도장, 보호, 임시 부착 등 다양한 현장에서 활용되는 기본 산업용 테이프입니다.',
            image: '/images/tape5.png',
            link: '/products/industrial/masking',
          },
          {
            id: 7,
            name: '라인 테이프',
            desc: '작업 구역 구분과 안전 동선 표시를 위해 사용하는 고시인성 라인 테이프입니다.',
            image: '/images/tape6.png',
            link: '/products/industrial/line',
          },
        ],
      },
      {
        key: 'foam',
        label: '폼테이프',
        eng: 'FOAM TAPE',
        items: [
          {
            id: 8,
            name: 'EVA폼 테이프',
            desc: '완충성과 밀착성이 우수하여 충격 흡수와 고정이 동시에 필요한 환경에 적합합니다.',
            image: '/images/tape8.png',
            link: '/products/foam/eva',
          },
          {
            id: 9,
            name: 'PE폼 테이프',
            desc: '안정적인 밀착 성능을 기반으로 조립 및 부착 공정에 활용되는 폼테이프입니다.',
            image: '/images/tape9.png',
            link: '/products/foam/pe',
          },
        ],
      },
    ],
    []
  );

  const [activeCategory, setActiveCategory] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);

  const [openPolicy, setOpenPolicy] = useState({
    sample: false,
    quote: false,
  });

  const [notices, setNotices] = useState([]);
  const [boardQuotes, setBoardQuotes] = useState([]);
  const [boardSamples, setBoardSamples] = useState([]);
  const [boardLoading, setBoardLoading] = useState(true);

  const [formData, setFormData] = useState({
    sample: {
      use_purpose: '',
      product_id: '',
      product_name: '',
      company_name: '',
      author_name: '',
      author_email: '',
      author_phone: '',
      address: '',
      password: '',
      agreed: false, // 개인정보 동의 여부 추가
      title: '샘플 요청 건',
      content: '샘플 요청 양식을 통한 자동 생성 내용입니다.',
    },
    quote: {
      use_purpose: '',
      product_ids: [],
      product_names: [],
      company_name: '',
      author_name: '',
      author_email: '',
      author_phone: '',
      quantity: '',
      password: '',
      agreed: false, // 개인정보 동의 여부 추가
      title: '견적 문의 건',
      content: '견적 문의 양식을 통한 자동 생성 내용입니다.',
    },
  });

  const currentCategory = productData[activeCategory];
  const currentItems = currentCategory.items;
  const allProducts = useMemo(() => productData.flatMap((cat) => cat.items), [productData]);

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        setBoardLoading(true);
        const [noticeRes, quoteRes, sampleRes] = await Promise.all([
          axios.get('/api/user/boards?board_type=notice'),
          axios.get('/api/user/requests?type=quote'),
          axios.get('/api/user/requests?type=sample'),
        ]);

        setNotices(Array.isArray(noticeRes.data) ? noticeRes.data.slice(0, 10) : []);
        setBoardQuotes(Array.isArray(quoteRes.data) ? quoteRes.data.slice(0, 4) : []);
        setBoardSamples(Array.isArray(sampleRes.data) ? sampleRes.data.slice(0, 4) : []);
      } catch (err) {
        console.error('데이터 로드 실패:', err);
      } finally {
        setBoardLoading(false);
      }
    };
    fetchBoards();
  }, []);

  const handleChangeCategory = (index) => {
    setActiveCategory(index);
    setActiveSlide(0);
  };

  const handleImageError = (e) => {
    e.currentTarget.src = 'https://dummyimage.com/1200x800/e8edf3/1a1a1a&text=IMAGE+COMING+SOON';
  };

  const handleInputChange = (type, e) => {
    const { name, value, type: inputType, checked, options } = e.target;

    if (name === 'product_id') {
      const selectedName = e.target.selectedIndex > 0 ? options[e.target.selectedIndex].text : '';
      setFormData((prev) => ({
        ...prev,
        [type]: { ...prev[type], product_id: value, product_name: selectedName },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [type]: { ...prev[type], [name]: inputType === 'checkbox' ? checked : value },
      }));
    }
  };

  const handleSubmitSample = async () => {
    // 개인정보 동의 체크
    if (!formData.sample.agreed) {
      alert('개인정보 수집 및 이용에 동의해주세요.');
      return;
    }

    try {
      // 기존 전송 코드 그대로 유지
      const res = await axios.post('/api/sample', formData.sample);

      alert('샘플 신청이 접수되었습니다.');
    } catch (err) {
      console.error(err);
      alert('전송 중 오류가 발생했습니다.');
    }
  };

  const handleQuoteProductClick = (id, name) => {
    setFormData((prev) => {
      const isSelected = prev.quote.product_ids.includes(id);
      const newIds = isSelected
        ? prev.quote.product_ids.filter((itemId) => itemId !== id)
        : [...prev.quote.product_ids, id];
      const newNames = isSelected
        ? prev.quote.product_names.filter((itemName) => itemName !== name)
        : [...prev.quote.product_names, name];
      return { ...prev, quote: { ...prev.quote, product_ids: newIds, product_names: newNames } };
    });
  };

  const handleSubmit = async (type) => {
    const data = formData[type];

    if (!data.agreed) {
      return alert('개인정보 수집 및 이용에 동의해주세요.');
    }

    const isSample = type === 'sample';
    const commonValid = data.use_purpose && data.company_name && data.author_name && data.author_phone && data.password;
    const specialValid = isSample ? data.product_id && data.address : data.product_ids.length > 0 && data.quantity;

    if (!commonValid || !specialValid) return alert('필수 항목(*)을 모두 입력해주세요.');

    try {
      const payload = {
        type,
        use_purpose: data.use_purpose,
        company_name: data.company_name,
        author_name: data.author_name,
        author_email: data.author_email,
        author_phone: data.author_phone,
        address: isSample ? data.address : null,
        password: data.password,
        title: data.title,
        content: data.content,
        is_private: 1,
        product_id: isSample ? data.product_id : null,
        product_name: isSample ? data.product_name : data.product_names.join(', '),
        quantity: isSample ? null : data.quantity,
      };

      const res = await axios.post('/api/user/requests/write', payload);
      if (res.data.success) {
        alert('성공적으로 접수되었습니다.');
        window.location.reload();
      }
    } catch (err) {
      alert(err.response?.data?.message || '오류가 발생했습니다.');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return dateString.substring(0, 10).replace(/-/g, '.');
  };

  return (
    <div className="home-container">
      {/* 1. 메인 비주얼 */}
      <section className="main-visual">
        <div className="video-background">
          <video autoPlay loop muted playsInline>
            <source src="/videos/main-hero.mp4" type="video/mp4" />
          </video>
          <div className="overlay"></div>
        </div>
        <div className="inner">
          <div className="scroll-guide">
            <div className="tape-anim-container">
              <div className="tape-roll">
                <div className="roll-inner"></div>
              </div>
              <div className="unrolling-tape">
                <div className="tape-body"></div>
              </div>
            </div>
            <span className="scroll-text">SCROLL DOWN</span>
          </div>
          <div className="text-wrap">
            <p className="tagline">PREMIUM INDUSTRIAL TAPE</p>
            <h1 className="main-title">
              <span className="brand-best">BEST</span>
              <span className="brand-trading">
                TRAD
                <span className="ing-wrap">
                  <span className="ing-text">ING</span>
                  <span className="tape-accent"></span>
                </span>
              </span>
            </h1>
            <h2 className="sub-title">산업용 · 특수 · 양면 테이프 전문 제조</h2>
            <div className="btn-group">
              <Link to="/products/double-sided/whaja">
                <button className="primary-btn">
                  제품소개 바로가기 <FiArrowRight />
                </button>
              </Link>
              <button
                className="secondary-btn"
                onClick={() =>
                  window.scrollTo({ top: document.querySelector('.request-section').offsetTop, behavior: 'smooth' })
                }
              >
                견적문의
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* 2. 제품 쇼케이스 */}
      <section className="product-showcase">
        <div className="showcase-head">
          <p className="eyebrow">PRODUCT LINEUP</p>
          <h3>제품 카테고리</h3>
          <p className="showcase-desc">원하시는 제품군을 선택하시면 상세 라인업을 확인하실 수 있습니다.</p>
        </div>
        <div className="showcase-container">
          <nav className="category-tabs">
            {productData.map((category, index) => (
              <button
                key={category.key}
                className={`tab-item ${activeCategory === index ? 'active' : ''}`}
                onClick={() => handleChangeCategory(index)}
              >
                <span className="tab-eng">{category.eng}</span>
                <span className="tab-label">{category.label}</span>
              </button>
            ))}
          </nav>
          <div className="product-grid-panel" key={currentCategory.key}>
            <div className={`product-card-grid count-${currentItems.length}`}>
              {currentItems.map((item) => (
                <div key={item.id} className="product-card">
                  <div className="card-bg-wrap">
                    <img src={item.image} alt={item.name} onError={handleImageError} className="bg-image" />
                    <div className="card-overlay"></div>
                  </div>
                  <div className="product-info">
                    <h5>{item.name}</h5>
                    <p>{item.desc}</p>
                    <button
                      className="detail-view-btn"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.location.href = item.link;
                      }}
                    >
                      VIEW DETAILS <FiArrowRight />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 3. 코어 경쟁력 */}
      <section className="competitiveness">
        <div className="video-background">
          <video autoPlay loop muted playsInline>
            <source src="/videos/competitiveness_background.mp4" type="video/mp4" />
          </video>
          <div className="video-overlay"></div>
        </div>
        <div className="inner">
          <div className="section-title">
            <span className="sub-title">CORE COMPETITIVENESS</span>
            <h3>
              베스트트레이딩만의 <strong>S.H.I.P</strong> 솔루션
            </h3>
          </div>
          <div className="core-grid">
            <div className="core-item">
              <div className="icon-box">
                <FiZap />
              </div>
              <div className="desc">
                <h4>Stable Supply</h4>
                <h5>안정적인 원자재 수급</h5>
              </div>
              <span className="bg-char">S</span>
            </div>
            <div className="core-item">
              <div className="icon-box">
                <FiShield />
              </div>
              <div className="desc">
                <h4>High Quality</h4>
                <h5>엄격한 품질 관리</h5>
              </div>
              <span className="bg-char">H</span>
            </div>
            <div className="core-item">
              <div className="icon-box">
                <FiTruck />
              </div>
              <div className="desc">
                <h4>Immediate Delivery</h4>
                <h5>신속 정확한 납기</h5>
              </div>
              <span className="bg-char">I</span>
            </div>
            <div className="core-item">
              <div className="icon-box">
                <FiHeadphones />
              </div>
              <div className="desc">
                <h4>Perfect Support</h4>
                <h5>철저한 사후관리</h5>
              </div>
              <span className="bg-char">P</span>
            </div>
          </div>
        </div>
      </section>

      {/* 4. 게시판 섹션 */}
      <section className="minimal-board-section">
        <div className="inner">
          <div className="section-title-area">
            <div className="title-left">
              <span className="sub-tag">NOTICE & REQUEST</span>
              <h2>공지사항 및 문의현황</h2>
            </div>
          </div>

          <div className="board-container">
            <div className="board-column notice-area">
              <div className="column-header">
                <div className="title-box">
                  <span className="eng">NOTICE</span>
                  <h3>공지사항</h3>
                </div>
                <a href="/community/notice" className="link-more">
                  VIEW ALL <FiPlus />
                </a>
              </div>
              <div className="column-body">
                <div className="list-head">
                  <span className="th-subject">제목</span>
                  <span className="th-date">등록일</span>
                </div>
                {boardLoading ? (
                  <div className="loading-state">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="sk-line" />
                    ))}
                  </div>
                ) : notices.length > 0 ? (
                  <ul className="post-list">
                    {notices.map((post) => (
                      <li key={post.id} className="post-item">
                        <a href={`/community/notice`}>
                          <div className="post-info">
                            {Number(post.is_pinned) === 1 && <span className="pin">공지</span>}
                            <span className="subject">{post.title}</span>
                          </div>
                          <span className="date">{formatDate(post.created_at)}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="empty-msg">등록된 공지사항이 없습니다.</div>
                )}
              </div>
            </div>
            <div className="right-side">
              <div className="board-column sample-area">
                <div className="column-header">
                  <div className="title-box">
                    <span className="eng">SAMPLE</span>
                    <h3>샘플요청</h3>
                  </div>
                  <a href="/request-sample" className="link-more">
                    VIEW ALL <FiPlus />
                  </a>
                </div>
                <div className="column-body">
                  <div className="list-head">
                    <span className="th-subject">제목</span>
                    <span className="th-date">등록일</span>
                  </div>
                  {boardLoading ? (
                    <div className="loading-state">
                      {[1, 2, 3].map((i) => (
                        <div key={i} className="sk-line" />
                      ))}
                    </div>
                  ) : boardSamples.length > 0 ? (
                    <ul className="post-list">
                      {boardSamples.map((post) => (
                        <li key={post.id} className="post-item">
                          <a href={`/request-sample`}>
                            <div className="post-info">
                              {Number(post.is_private) === 1 && <span className="pin secret">비밀글</span>}
                              <span className="subject">{post.title}</span>
                            </div>
                            <span className="date">{formatDate(post.created_at)}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="empty-msg">등록된 샘플요청이 없습니다.</div>
                  )}
                </div>
              </div>

              <div className="board-column quote-area">
                <div className="column-header">
                  <div className="title-box">
                    <span className="eng">QUOTE</span>
                    <h3>견적문의</h3>
                  </div>
                  <a href="/request-quote" className="link-more">
                    VIEW ALL <FiPlus />
                  </a>
                </div>
                <div className="column-body">
                  <div className="list-head">
                    <span className="th-subject">제목</span>
                    <span className="th-date">등록일</span>
                  </div>
                  {boardLoading ? (
                    <div className="loading-state">
                      {[1, 2, 3].map((i) => (
                        <div key={i} className="sk-line" />
                      ))}
                    </div>
                  ) : boardQuotes.length > 0 ? (
                    <ul className="post-list">
                      {boardQuotes.map((post) => (
                        <li key={post.id} className="post-item">
                          <a href={`/request-quote`}>
                            <div className="post-info">
                              {Number(post.is_private) === 1 && <span className="pin secret">비밀글</span>}
                              <span className="subject">{post.title}</span>
                            </div>
                            <span className="date">{formatDate(post.created_at)}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="empty-msg">등록된 견적문의가 없습니다.</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. 신청 섹션 (통합본) */}
      <section className="request-section">
        <div className="bg-text-layer">
          <span className="bg-text-item best">BEST</span>
          <span className="bg-text-item trading">TRADING</span>
        </div>
        <div className="inner">
          <div className="request-intro">
            <p className="eyebrow">CONTACT US</p>
            <h3>샘플 및 견적 문의</h3>
            <p>샘플 요청 또는 견적 문의를 남겨주세요. 담당자가 확인 후 안내드립니다.</p>
          </div>
          <div className="request-grid">
            {/* 샘플 요청 카드 */}
            <div className="request-card sample">
              <div className="card-head">
                <span className="card-badge">SAMPLE</span>
                <h4>샘플 요청</h4>
              </div>
              <div className="card-body">
                <input
                  type="text"
                  name="use_purpose"
                  placeholder="사용용도 *"
                  value={formData.sample.use_purpose}
                  onChange={(e) => handleInputChange('sample', e)}
                />
                <div className="product-check-group">
                  <p className="label">샘플요청제품 선택 *</p>
                  <div className="check-list">
                    {allProducts.map((p) => (
                      <label
                        key={p.id}
                        className={`check-item ${formData.sample.product_id === String(p.id) ? 'active' : ''}`}
                      >
                        <input
                          type="checkbox"
                          checked={formData.sample.product_id === String(p.id)}
                          onChange={() => {
                            const val = formData.sample.product_id === String(p.id) ? '' : String(p.id);
                            setFormData((prev) => ({
                              ...prev,
                              sample: { ...prev.sample, product_id: val, product_name: val ? p.name : '' },
                            }));
                          }}
                        />
                        <span>{p.name}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div className="row">
                  <input
                    type="text"
                    name="company_name"
                    placeholder="회사 *"
                    value={formData.sample.company_name}
                    onChange={(e) => handleInputChange('sample', e)}
                  />
                  <input
                    type="text"
                    name="author_email"
                    placeholder="이메일 *"
                    value={formData.sample.author_email}
                    onChange={(e) => handleInputChange('sample', e)}
                  />
                </div>
                <div className="row">
                  <input
                    type="text"
                    name="author_name"
                    placeholder="성명 *"
                    value={formData.sample.author_name}
                    onChange={(e) => handleInputChange('sample', e)}
                  />
                  <input
                    type="text"
                    name="author_phone"
                    placeholder="연락처 *"
                    value={formData.sample.author_phone}
                    onChange={(e) => handleInputChange('sample', e)}
                  />
                </div>
                <input
                  type="text"
                  name="address"
                  placeholder="주소 *"
                  value={formData.sample.address}
                  onChange={(e) => handleInputChange('sample', e)}
                />

                {/* 비밀번호 필드 추가 (샘플) */}
                <input
                  type="password"
                  name="password"
                  placeholder="문의 비밀번호 *"
                  value={formData.sample.password}
                  onChange={(e) => handleInputChange('sample', e)}
                  required
                />

                <div className="privacy-consent">
                  <div className="privacy-title-row">
                    <label className="privacy-check">
                      <input
                        type="checkbox"
                        name="agreed"
                        checked={formData.sample.agreed}
                        onChange={(e) => handleInputChange('sample', e)}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <div className="privacy-title">개인정보 수집 및 이용 동의 (필수)</div>
                  </div>
                  <div className="privacy-scroll-box">
                    <p>
                      <strong>개인정보 수집 및 이용 동의</strong>
                    </p>
                    <p>
                      <strong>1. 수집 목적</strong>
                      <br />
                      샘플 제공, 제품 상담, 문의 응대, 서비스 제공 및 관련 업무 처리
                    </p>
                    <p>
                      <strong>2. 수집 항목</strong>
                      <br />
                      회사명, 성명, 연락처, 이메일, 주소, 비밀번호
                    </p>
                    <p>
                      <strong>3. 보유 및 이용 기간</strong>
                      <br />
                      수집일로부터 3년 보관 후 지체 없이 파기합니다.
                    </p>
                    <p>
                      <strong>4. 동의 거부 권리</strong>
                      <br />
                      귀하는 동의를 거부할 권리가 있으며, 거부 시 서비스 이용이 제한될 수 있습니다.
                    </p>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => handleSubmit('sample')}
                  disabled={!formData.sample.agreed}
                  className={!formData.sample.agreed ? 'disabled' : ''}
                >
                  샘플 신청하기 <FiSend />
                </button>
              </div>
            </div>

            {/* 견적 요청 카드 */}
            <div className="request-card quote">
              <div className="card-head">
                <span className="card-badge">QUOTE</span>
                <h4>견적 요청</h4>
              </div>
              <div className="card-body">
                <input
                  type="text"
                  name="use_purpose"
                  placeholder="사용용도 *"
                  value={formData.quote.use_purpose}
                  onChange={(e) => handleInputChange('quote', e)}
                />
                <div className="product-check-group">
                  <p className="label">제품 선택 (중복가능) *</p>
                  <div className="check-list">
                    {allProducts.map((p) => (
                      <label
                        key={p.id}
                        className={`check-item ${formData.quote.product_ids.includes(String(p.id)) ? 'active' : ''}`}
                      >
                        <input
                          type="checkbox"
                          checked={formData.quote.product_ids.includes(String(p.id))}
                          onChange={() => handleQuoteProductClick(String(p.id), p.name)}
                        />
                        <span>{p.name}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div className="row">
                  <input
                    type="text"
                    name="company_name"
                    placeholder="회사 *"
                    value={formData.quote.company_name}
                    onChange={(e) => handleInputChange('quote', e)}
                  />
                  <input
                    type="text"
                    name="author_email"
                    placeholder="이메일 *"
                    value={formData.quote.author_email}
                    onChange={(e) => handleInputChange('quote', e)}
                  />
                </div>
                <div className="row">
                  <input
                    type="text"
                    name="author_name"
                    placeholder="성명 *"
                    value={formData.quote.author_name}
                    onChange={(e) => handleInputChange('quote', e)}
                  />
                  <input
                    type="text"
                    name="author_phone"
                    placeholder="연락처 *"
                    value={formData.quote.author_phone}
                    onChange={(e) => handleInputChange('quote', e)}
                  />
                </div>
                <input
                  type="text"
                  name="quantity"
                  placeholder="수량 *"
                  value={formData.quote.quantity}
                  onChange={(e) => handleInputChange('quote', e)}
                />

                {/* 비밀번호 필드 추가 (견적) */}
                <input
                  type="password"
                  name="password"
                  placeholder="문의 비밀번호 *"
                  value={formData.quote.password}
                  onChange={(e) => handleInputChange('quote', e)}
                  required
                />

                <div className="privacy-consent">
                  <div className="privacy-title-row">
                    <label className="privacy-check">
                      <input
                        type="checkbox"
                        name="agreed"
                        checked={formData.quote.agreed}
                        onChange={(e) => handleInputChange('quote', e)}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <div className="privacy-title">개인정보 수집 및 이용 동의 (필수)</div>
                  </div>
                  <div className="privacy-scroll-box">
                    <p>
                      <strong>개인정보 수집 및 이용 동의</strong>
                    </p>
                    <p>
                      <strong>1. 수집 목적</strong>
                      <br />
                      견적 문의 응대, 상담 진행, 서비스 안내 및 관련 업무 처리
                    </p>
                    <p>
                      <strong>2. 수집 항목</strong>
                      <br />
                      회사명, 성명, 연락처, 이메일, 비밀번호
                    </p>
                    <p>
                      <strong>3. 보유 및 이용 기간</strong>
                      <br />
                      수집일로부터 3년 보관 후 지체 없이 파기합니다.
                    </p>
                    <p>
                      <strong>4. 동의 거부 권리</strong>
                      <br />
                      귀하는 동의를 거부할 권리가 있으며, 거부 시 서비스 이용이 제한될 수 있습니다.
                    </p>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => handleSubmit('quote')}
                  disabled={!formData.quote.agreed}
                  className={!formData.quote.agreed ? 'disabled' : ''}
                >
                  견적 문의하기 <FiSend />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
